import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { StoreConcessionList as RedesignStoreConcessionList } from '../../../pages';
import * as Api from '../../Api';
import * as Data from '../../Data';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyConcessionList } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignStoreConcessionList,
  LegacyConcessionList,
);

export type StateProps = {
  AppDesignScheme: Api.AppDesignScheme;
  CollectionSummaries: Data.Async<Api.CollectionRestaurantSummary[]>;
  isDark: boolean;
  Menus: Store.MenuData;
  translate: any;
};

const mapStateToProps = (state: Store.State): StateProps => ({
  AppDesignScheme: state.appDesignScheme,
  CollectionSummaries: state.flipdish.CollectionSummaries,
  isDark: state.flipdish.isDark,
  Menus: state.flipdish.MenuData,
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(pageComponent);
